// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"327":"a70ef105","891":"9459a7d1","931":"649072df"}[chunkId] + ".chunk.css";
};